import { render, staticRenderFns } from "./edit-document-template.vue?vue&type=template&id=1a16f1f9&scoped=true&"
import script from "./edit-document-template.vue?vue&type=script&lang=js&"
export * from "./edit-document-template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a16f1f9",
  null
  
)

export default component.exports